import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import WpTooltipsWrapper from './wrappers/wp-tooltips-wrapper/wp-tooltips-wrapper.tsx';

const WpTooltipsWrapperRender = WpTooltipsWrapper(App);
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
//	<React.StrictMode>
		<WpTooltipsWrapperRender />
//	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();